export { default } from './src/index';